module.exports = __webpack_public_path__ + "static/img/system-maintenance.1275ae6b.png";